<template>
    <v-card-text>
        <div v-for="(item, idx) in items" :key="idx" class="body-1">
            {{ `· ${item.content}` }}
        </div>
    </v-card-text>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
